import { Injectable, inject, signal } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { BasePaginationService } from '@components/pagination/pagination.type'
import { MaintenanceWithLinkedProductsServicesGQL, PageInfo, ProductServiceOrderByInput, ProductServiceType, ProductsServicesForTabGQL } from '@generated/sammathnaur.graphql'
import { Subject, firstValueFrom } from 'rxjs'
import { MaintenanceServiceItem } from '../maintenance-services-tab.type'

@Injectable({
  providedIn: 'root',
})
export class MaintenanceServicesTabService implements BasePaginationService {
  public readonly search$ = new Subject<void>()
  public readonly filterForm = new FormGroup({
    name_contains: new FormControl<string | null>(null),
  })

  public orderBy = signal<ProductServiceOrderByInput>(ProductServiceOrderByInput.NameAsc)
  public limit = signal<number>(25)
  public offset = signal<number>(0)
  public totalCount = signal<number>(0)
  public pageInfo = signal<PageInfo | undefined>(undefined)
  public isLoading = signal<boolean>(false)

  private readonly productsServicesForTabGQL = inject(ProductsServicesForTabGQL)
  private readonly maintenanceWithLinkedProductsServicesGQL = inject(MaintenanceWithLinkedProductsServicesGQL)

  public async loadLinkedServices(maintenanceId: string): Promise<MaintenanceServiceItem[]> {
    const result = await firstValueFrom(
      this.maintenanceWithLinkedProductsServicesGQL.fetch({
        variables: {
          id: maintenanceId,
          where: { type: ProductServiceType.Service },
        },
      }),
    )
    return (result.data?.maintenance?.productsServices?.items ?? []).map((ps) => ({
      id: ps.item.id,
      name: ps.item.name,
    }))
  }

  public async searchPage(): Promise<MaintenanceServiceItem[]> {
    this.isLoading.set(true)
    try {
      const { name_contains } = this.filterForm.value
      const result = await firstValueFrom(
        this.productsServicesForTabGQL.fetch({
          variables: {
            where: {
              name_contains: name_contains ?? undefined,
              type_in: [ProductServiceType.Service],
              archived: false,
            },
            limit: this.limit(),
            offset: this.offset(),
            orderBy: this.orderBy(),
          },
        }),
      )
      return (result.data?.productsServices?.items ?? []).map((item) => ({ id: item.id, name: item.name }))
    } finally {
      this.isLoading.set(false)
    }
  }
}
